<template>
  <div class="vehicles-container">
    <el-table :data="sharecarInfo.result"
              style="width: 100%"
              height='100%'>
      <el-table-column class-name="number"
                       label="序号"
                       align="center"
                       type="index"
                       min-width="50"
                       fixed>
      </el-table-column>
      <el-table-column class-name="carNumber"
                       prop="optionsId"
                       label="车源编号"
                       width="110"
                       header-align="center"
                       align="center">
      </el-table-column>
      <el-table-column header-align="center"
                       align="center"
                       label="公司名称"
                       min-width="120">
        <template slot-scope="scope">
          <div>{{scope.row.companyName}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="companyPhone"
                       label="公司电话"
                       header-align="center"
                       align="center"
                       width="106">
      </el-table-column>
      <el-table-column label="出发地"
                       header-align="center"
                       align="center"
                       min-width="120">
        <template slot-scope="scope">
          <div>{{scope.row.startingAddressName}}</div>
        </template>
      </el-table-column>
      <el-table-column label="目的地"
                       header-align="center"
                       align="center"
                       min-width="130">
        <template slot-scope="scope">
          <div>{{scope.row.endAddressName}}</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       prop="createDate"
                       label="发布时间"
                       min-width="100"
                       align="center"></el-table-column>
      <el-table-column prop="remark"
                       label="备注"
                       header-align="center"
                       align="center"
                       min-width="100"></el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{sharecarInfo.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="sharecarInfo.pageSize"
                     layout="prev, pager, next"
                     :total="sharecarInfo.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import { shareCar } from 'apis/index'
import { mapState } from 'vuex'
import Bus from '../../Bus.js'
export default {
  name: 'Container',
  data () {
    return {
      searchInfo: {},
      pageNum: 1
    }
  },
  computed: mapState({
    sharecarInfo: state => state.shareCar.sharecarInfo
  }),
  mounted () {
    this.getCarlist()
    Bus.$on('getSearchInfo', res => {
      this.searchInfo = res
    })
  },
  methods: {
    getCarlist () {
      shareCar({
        startingAddressName: this.from,
        endAddressName: this.to,
        pageNum: this.pageNum
      }).then(res => {
        if (res.data.code === 0) {
          const sharecarInfo = res.data.data.pagination
          this.$store.commit('shareCar/updateData', sharecarInfo)
        }
        // console.log(this.sharecarInfo)
      })
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getCarlist()
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.vehicles-container
  height calc(100% - 85px)
  .el-table
    background #f7f9fb
    .cell
      size12()
  .el-table th
    background #e7f0f8
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
